export const payment = ({ id, token }) => ({
  HTTPMethod: "get",
  path: `/payments/${id}`,
  queryParams: {},
  body: null,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
